/* global Blockly */
import React from 'react';
import {signatureIcon} from "./index";

// everything here should be ES5
function defineBlock(context) {
    return {
        init: function () {
            this.appendDummyInput('VALUE')
                .appendField('reset signature')
                .appendField(new Blockly.FieldImage(signatureIcon, 50, 30, 'signature icon', null), 'signatureIcon')
                .appendField(new Blockly.FieldWidgetsDropdown(context,'signature', undefined, '- select -'), 'DD');
            this.setPreviousStatement(true);
            this.setNextStatement(true);
            this.setOutput(false);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Reset the selected signature widget');
        },
        onchange: function(){
            if (this.getField('signatureIcon') && this.getField('signatureIcon').imageElement_)
                this.getField('signatureIcon').setTooltip('Signature');
        }
    }
}

// everything here should be ES5
function defineGenerators() {
    return {
        'JavaScript': function (block) {
            const id = block.getFieldValue('DD');
            const code = `Snap.widgets.signature.reset('${id}');\n`;

            return code;
        }
    }
}

const ResetSignature = function (props) {
    const name = 'snap_reset_signature';
    ResetSignature.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    if (!props.widgets || props.widgets.length < 1) {
        return null;
    }

    return (
        <block type={name}>
            {
                props.widget && (props.widget.id !== undefined) ?
                    <field name='DD'>{props.widget.id}</field>
                    : null
            }
        </block>
    );
}

export default ResetSignature;